// filepath: client/src/services/apiUsersService.js
import axios from 'axios';
const API_URL = import.meta.env.VITE_API_URL;
import { isCustomer, buildAuthHeaders } from '#client/utils/helpers/services.js';

export const apiUsersService = {
    /**
     * Fetch all API users
     */
    async fetchApiUsers() {
        const { isCustomerUser } = isCustomer();
        const response = await axios.get(`${API_URL}/app/api-users`, {
            headers: buildAuthHeaders(isCustomerUser),
        });
        return response.data?.data || [];
    },

    /**
     * Create a new API user
     * @param {string} username - Username for the new API user
     */
    async createApiUser(username) {
        const { isCustomerUser } = isCustomer();

        const response = await axios.post(
            `${API_URL}/app/api-users`,
            {
                username,
            },
            {
                headers: buildAuthHeaders(isCustomerUser),
            }
        );

        return response.data?.data || null;
    },

    /**
     * Delete an API user
     * @param {string} userId - ID of the user to delete
     */
    async deleteApiUser(userId) {
        const { isCustomerUser } = isCustomer();

        const response = await axios.delete(`${API_URL}/app/api-users/${userId}`, {
            headers: buildAuthHeaders(isCustomerUser),
        });
        return response.data;
    },
};
